import React from 'react';
import EmptyCell from './EmptyCell';

export default cellText => {
    if (cellText === null) {
        return <EmptyCell />;
    }
    return <span>{cellText}</span>;
};
